import React, { useState, useEffect } from 'react'
import Layout from '../components/Layout'
import api from '../services/api'
import { useModal } from '../components/Modal'

export default function MayorPage() {
  const { showAlert, showConfirm, ModalComponents } = useModal()
  const [contracts, setContracts] = useState([])
  const [loading, setLoading] = useState(true)
  const [selected, setSelected] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [saving, setSaving] = useState(false)
  const [mayorData, setMayorData] = useState(null)
  const [signed, setSigned] = useState(false)
  const [confirmPassword, setConfirmPassword] = useState('')

  useEffect(() => {
    fetchPendingContracts()
    fetchMayorData()
  }, [])

  const fetchMayorData = async () => {
    try {
      const res = await api.get('/users/me')
      if (res.data.success) setMayorData(res.data.data)
    } catch (err) { console.error(err) }
  }

  const fetchPendingContracts = async () => {
    try {
      setLoading(true)
      const res = await api.get('/contracts/mayor-pending')
      if (res.data.success) setContracts(res.data.data)
    } catch (err) { console.error(err) }
    finally { setLoading(false) }
  }

  const openModal = async (contract) => {
    try {
      const res = await api.get(`/contracts/${contract.id}`)
      if (res.data.success) { setSelected(res.data.data); setShowModal(true); setSigned(false); setConfirmPassword('') }
    } catch (err) { console.error(err) }
  }

  const handleSign = async () => {
    if (!signed) { showAlert('warning', 'ยังไม่ได้ลงนาม', 'กรุณากดปุ่ม "กดเพื่อลงนาม" ก่อน'); return }
    if (!mayorData?.signature_image) { showAlert('warning', 'ไม่พบลายเซ็น', 'กรุณาติดต่อ HR เพื่ออัปโหลดลายเซ็นก่อน'); return }
    const ok = await showConfirm('success', 'ยืนยันลงนามสัญญา', `ยืนยันการลงนามสัญญา ${selected.contract_no} ใช่หรือไม่?`)
    if (!ok) return
    try {
      setSaving(true)
      await api.post(`/contracts/${selected.id}/mayor-sign`, { confirm_password: confirmPassword })
      setShowModal(false)
      fetchPendingContracts()
      showAlert('success', 'ลงนามสำเร็จ', 'ลงนามสัญญาสำเร็จแล้ว')
    } catch (err) { showAlert('error', 'เกิดข้อผิดพลาด', err.response?.data?.message || 'เกิดข้อผิดพลาด') }
    finally { setSaving(false) }
  }

  return (
    <Layout>
      <ModalComponents />
      <div className="ice-list-page" style={{ maxWidth: '1200px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ fontSize: '20px', fontWeight: '500', color: '#0f172a' }}>รอลงนาม</h1>
          <p style={{ fontSize: '13px', color: '#94a3b8', marginTop: '4px' }}>สัญญาที่ HR อนุมัติแล้ว รอท่านนายกลงนาม</p>
        </div>

        {/* Warning */}
        {!mayorData?.signature_image && (
          <div style={{ background: '#fef9c3', border: '0.5px solid #fde68a', borderRadius: '12px', padding: '14px 16px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ width: '34px', height: '34px', background: '#fef08a', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <i className="ti ti-alert-triangle" style={{ fontSize: '18px', color: '#f59e0b' }} />
            </div>
            <p style={{ fontSize: '13px', color: '#713f12' }}>ท่านยังไม่ได้อัปโหลดลายเซ็น กรุณาติดต่อ HR เพื่ออัปโหลดก่อน</p>
          </div>
        )}

        {/* Table */}
        <div style={{ background: 'white', borderRadius: '14px', border: '0.5px solid #e2e8f0', overflow: 'hidden' }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8', fontSize: '13px' }}>กำลังโหลด...</div>
          ) : contracts.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px' }}>
              <i className="ti ti-circle-check" style={{ fontSize: '48px', color: '#22c55e', display: 'block', marginBottom: '12px' }} />
              <p style={{ color: '#94a3b8', fontSize: '13px' }}>ไม่มีสัญญารอลงนาม</p>
            </div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f8fafc' }}>
                    {['เลขสัญญา', 'พนักงาน', 'กองงาน', 'ประเภท', 'วันเริ่ม', 'วันหมด', 'เงินเดือน', 'จัดการ'].map(h => (
                      <th key={h} style={{ textAlign: 'left', padding: '10px 16px', fontSize: '11px', color: '#94a3b8', fontWeight: '500', whiteSpace: 'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {contracts.map(c => (
                    <tr key={c.id} style={{ borderTop: '0.5px solid #f1f5f9' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      <td style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '500', color: '#0f172a' }}>{c.contract_no}</td>
                      <td style={{ padding: '12px 16px', fontSize: '13px', color: '#334155' }}>{c.prefix}{c.first_name} {c.last_name}</td>
                      <td style={{ padding: '12px 16px', fontSize: '12px', color: '#94a3b8' }}>{c.division_name || '-'}</td>
                      <td style={{ padding: '12px 16px' }}>
                        <span style={{ display: 'inline-flex', padding: '3px 10px', borderRadius: '999px', fontSize: '11px', background: '#eff6ff', color: '#075dcc' }}>{c.emp_type}</span>
                      </td>
                      <td style={{ padding: '12px 16px', fontSize: '12px', color: '#94a3b8', whiteSpace: 'nowrap' }}>{new Date(c.start_date).toLocaleDateString('th-TH')}</td>
                      <td style={{ padding: '12px 16px', fontSize: '12px', color: '#94a3b8', whiteSpace: 'nowrap' }}>{new Date(c.end_date).toLocaleDateString('th-TH')}</td>
                      <td style={{ padding: '12px 16px', fontSize: '13px', color: '#334155', whiteSpace: 'nowrap' }}>{Number(c.total_salary).toLocaleString('th-TH')} บ.</td>
                      <td style={{ padding: '12px 16px' }}>
                        <button onClick={() => openModal(c)}
                          style={{ padding: '6px 14px', background: '#16a34a', color: 'white', border: 'none', borderRadius: '8px', fontSize: '12px', fontWeight: '500', cursor: 'pointer' }}>
                          ดูและลงนาม
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Modal */}
      {showModal && selected && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: '16px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '100%', maxWidth: '600px', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ padding: '20px 24px', borderBottom: '0.5px solid #f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div>
                <p style={{ fontSize: '15px', fontWeight: '500', color: '#0f172a' }}>ลงนามสัญญา</p>
                <p style={{ fontSize: '12px', color: '#94a3b8', marginTop: '2px' }}>เลขสัญญา {selected.contract_no}</p>
              </div>
              <button onClick={() => setShowModal(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', fontSize: '20px' }}>×</button>
            </div>

            <div style={{ padding: '20px 24px' }}>
              {/* ข้อมูลพนักงาน */}
              <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '16px', marginBottom: '14px' }}>
                <p style={{ fontSize: '10px', fontWeight: '500', color: '#94a3b8', textTransform: 'uppercase', marginBottom: '12px' }}>ข้อมูลพนักงาน</p>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                  {[
                    ['ชื่อ-นามสกุล', `${selected.prefix}${selected.first_name} ${selected.last_name}`],
                    ['เลขบัตร', selected.id_card || '-'],
                    ['กองงาน', selected.division_name || '-'],
                    ['ตำแหน่ง', selected.position || '-'],
                    ['วันเริ่ม', new Date(selected.start_date).toLocaleDateString('th-TH')],
                    ['วันหมด', new Date(selected.end_date).toLocaleDateString('th-TH')],
                  ].map(([label, value]) => (
                    <div key={label}>
                      <p style={{ fontSize: '11px', color: '#94a3b8' }}>{label}</p>
                      <p style={{ fontSize: '13px', fontWeight: '500', color: '#0f172a', marginTop: '2px' }}>{value}</p>
                    </div>
                  ))}
                  <div style={{ gridColumn: 'span 2' }}>
                    <p style={{ fontSize: '11px', color: '#94a3b8' }}>ค่าตอบแทนรวม</p>
                    <p style={{ fontSize: '20px', fontWeight: '500', color: '#16a34a', marginTop: '2px' }}>{Number(selected.total_salary).toLocaleString('th-TH')} บาท/เดือน</p>
                  </div>
                </div>
              </div>

              {/* ลายเซ็นพนักงาน */}
              {selected.signatures?.filter(s => s.signer_role === 'employee').map((sig, i) => (
                <div key={i} style={{ background: '#f0fdf4', border: '0.5px solid #bbf7d0', borderRadius: '12px', padding: '14px', marginBottom: '12px' }}>
                  <p style={{ fontSize: '11px', fontWeight: '500', color: '#16a34a', marginBottom: '8px' }}>✅ ลายเซ็นพนักงาน</p>
                  <img src={sig.sig_data} alt="ลายเซ็นพนักงาน" style={{ maxHeight: '48px', border: '0.5px solid #bbf7d0', borderRadius: '8px', background: 'white', padding: '4px' }} />
                </div>
              ))}

              {/* ลายเซ็นพยาน */}
              {(selected.witness1_sig || selected.witness2_sig) && (
                <div style={{ background: '#eff6ff', border: '0.5px solid #bfdbfe', borderRadius: '12px', padding: '14px', marginBottom: '12px' }}>
                  <p style={{ fontSize: '11px', fontWeight: '500', color: '#1d4ed8', marginBottom: '10px' }}>✅ ลายเซ็นพยาน HR</p>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                    {selected.witness1_sig && (
                      <div>
                        <p style={{ fontSize: '11px', color: '#64748b', marginBottom: '6px' }}>พยาน 1 — {selected.witness1_name}</p>
                        <img src={selected.witness1_sig} alt="พยาน 1" style={{ maxHeight: '48px', border: '0.5px solid #bfdbfe', borderRadius: '8px', background: 'white', padding: '4px' }} />
                      </div>
                    )}
                    {selected.witness2_sig && (
                      <div>
                        <p style={{ fontSize: '11px', color: '#64748b', marginBottom: '6px' }}>พยาน 2 — {selected.witness2_name}</p>
                        <img src={selected.witness2_sig} alt="พยาน 2" style={{ maxHeight: '48px', border: '0.5px solid #bfdbfe', borderRadius: '8px', background: 'white', padding: '4px' }} />
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* ลงนามนายก */}
              <div style={{ background: '#f0fdf4', border: '0.5px solid #bbf7d0', borderRadius: '12px', padding: '16px', marginBottom: '16px' }}>
                <p style={{ fontSize: '11px', fontWeight: '500', color: '#94a3b8', textTransform: 'uppercase', marginBottom: '12px' }}>ลายเซ็นนายกเทศมนตรี</p>
                {mayorData?.signature_image ? (
                  <div>
                    <div style={{ background: 'white', border: '0.5px solid #bbf7d0', borderRadius: '10px', padding: '14px', marginBottom: '12px', textAlign: 'center' }}>
                      <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '8px' }}>{mayorData.full_name}</p>
                      {signed ? (
                        <img src={mayorData.signature_image} alt="ลายเซ็นนายก" style={{ maxHeight: '64px', margin: '0 auto' }} />
                      ) : (
                        <p style={{ fontSize: '12px', color: '#94a3b8', padding: '16px 0' }}>กดปุ่มด้านล่างเพื่อลงนาม</p>
                      )}
                    </div>
                    {signed ? (
                      <div style={{ textAlign: 'center' }}>
                        <p style={{ fontSize: '13px', color: '#16a34a', fontWeight: '500' }}>✓ ลงนามแล้ว</p>
                        <button onClick={() => setSigned(false)} style={{ fontSize: '11px', color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer', marginTop: '4px' }}>ยกเลิก</button>
                      </div>
                    ) : (
                      <button onClick={() => setSigned(true)}
                        style={{ width: '100%', padding: '10px', background: '#16a34a', color: 'white', border: 'none', borderRadius: '10px', fontSize: '13px', fontWeight: '500', cursor: 'pointer' }}>
                        กดเพื่อลงนาม
                      </button>
                    )}
                  </div>
                ) : (
                  <div style={{ background: '#fef2f2', border: '0.5px solid #fecaca', borderRadius: '10px', padding: '12px' }}>
                    <p style={{ fontSize: '12px', color: '#ef4444' }}>ไม่พบลายเซ็น กรุณาติดต่อ HR เพื่ออัปโหลดก่อน</p>
                  </div>
                )}
              </div>

              <div style={{ marginBottom: '16px' }}>
                <label htmlFor="mayor-confirm-password" style={{ display: 'block', fontSize: '12px', fontWeight: '500', color: '#334155', marginBottom: '6px' }}>ยืนยันรหัสผ่านของท่านก่อนลงนาม</label>
                <input id="mayor-confirm-password" type="password" value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)} autoComplete="current-password"
                  placeholder="กรอกรหัสผ่านบัญชีปัจจุบัน"
                  style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', border: '1px solid #cbd5e1', borderRadius: '10px', fontSize: '13px', outline: 'none' }} />
                <p style={{ fontSize: '11px', color: '#64748b', marginTop: '5px' }}>ระบบใช้เพื่อยืนยันตัวตนครั้งนี้เท่านั้น และไม่บันทึกรหัสผ่านลง Audit Log</p>
              </div>

              {/* ปุ่ม */}
              <div style={{ display: 'flex', gap: '10px' }}>
                <button onClick={() => setShowModal(false)}
                  style={{ flex: 1, padding: '10px', background: 'white', color: '#64748b', border: '0.5px solid #e2e8f0', borderRadius: '10px', fontSize: '13px', cursor: 'pointer' }}>
                  ยกเลิก
                </button>
                <button onClick={handleSign} disabled={saving || !signed || !confirmPassword}
                  style={{ flex: 1, padding: '10px', background: saving || !signed ? '#86efac' : '#16a34a', color: 'white', border: 'none', borderRadius: '10px', fontSize: '13px', fontWeight: '500', cursor: saving || !signed ? 'not-allowed' : 'pointer' }}>
                  {saving ? 'กำลังลงนาม...' : 'ยืนยันลงนามสัญญา'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  )
}
